import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import PageBase from '../../../widgets/PageBase/PageBase';
import { Button, MenuItem, Select, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import './ImitableEmployeePage.css';
import DataTable from '../../../widgets/data-table/DataTable/DataTable';
import * as UserType from '../../../../constants/UserType';
import DataTablePagination from '../../../widgets/data-table/DataTable/DataTablePagination/DataTablePagination';
import { Checkbox } from 'material-ui';

const columns = (props) => [
  {
    header: {
      display: 'Employee ID'
    },
    accessor: (employee) => ({
      display: employee.employeeId
    })
  },
  {
    header: {
      display: 'Branch Code'
    },
    accessor: (employee) => ({
      display: employee.branchCode
    })
  },
  {
    header: {
      display: 'Branch Description'
    },
    accessor: (employee) => ({
      display: employee.branchDescription
    })
  },
  {
    header: {
      display: 'Branch Role'
    },
    accessor: (employee) => ({
      display: props.intl.formatMessage({
        id: UserType[employee.jobFunction].displayName
      })
    })
  },
  {
    header: {
      display: 'Title'
    },
    accessor: (employee) => ({
      display: employee.jobTitle
    })
  },
  {
    header: {
      display: 'Employee Name'
    },
    accessor: (employee) => ({
      display: employee.employeeName
    })
  },
  {
    header: {
      display: 'Is Override'
    },
    accessor: (employee) => ({
      display: <Checkbox checked={employee.isOverride} disabled />
    })
  }
];

const ImitateEmployeePage = (props) => {
  const getData = () =>
    props.employees
      .sort((a, b) => a.branchCode.localeCompare(b.branchCode))
      .map((employee) => ({
        ...employee,
        onClick: () => props.onSelectEmployee(employee)
      }));

  return (
    <div>
      <PageBase navigation={['Imitate']} includeInactiveBranches>
        <form onSubmit={props.onSearch}>
          <div className="row">
            <Select
              className="col-xs-12 col-md-2 input-element"
              value={props.selectedUserType}
              onChange={(event) => {
                props.onChangeUserType(event.target.value);
                props.onSearch();
              }}
            >
              {props.userTypes.map((userType, index) => (
                <MenuItem key={index} value={userType.name}>
                  {props.intl.formatMessage({ id: userType.displayName })}
                </MenuItem>
              ))}
            </Select>
            <TextField
              placeholder="First Name"
              fullWidth
              className="col-xs-12 col-md-4 input-element"
              value={props.firstName}
              onChange={(event) => props.onChangeFirstName(event.target.value)}
            />
            <TextField
              placeholder="Last Name"
              fullWidth
              className="col-xs-12 col-md-4 input-element"
              value={props.lastName}
              onChange={(event) => props.onChangeLastName(event.target.value)}
            />
            <span className="btn-search input-element">
              <Button onClick={props.onSearch} type="submit">
                <Search style={{ color: 'white' }} />
              </Button>
            </span>
          </div>
        </form>
        <div className="row">
          <div className="col-xs-12 col-md-8 col-md-offset-2">
            <DataTable
              columns={columns(props)}
              bodyData={getData()}
              footerContent={
                <DataTablePagination
                  page={props.page}
                  onChangePage={props.handleChangePage}
                  onChangeRowsPerPage={props.handleChangeRowsPerPage}
                  rowsPerPageOptions={props.rowsPerPageOptions}
                />
              }
            />
          </div>
        </div>
      </PageBase>
    </div>
  );
};

ImitateEmployeePage.propTypes = {
  onSearch: PropTypes.func.isRequired,
  userTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedUserType: PropTypes.string.isRequired,
  onChangeUserType: PropTypes.func.isRequired,
  firstName: PropTypes.string.isRequired,
  onChangeFirstName: PropTypes.func.isRequired,
  lastName: PropTypes.string.isRequired,
  onChangeLastName: PropTypes.func.isRequired,
  employees: PropTypes.arrayOf(PropTypes.object.isRequired),
  onSelectEmployee: PropTypes.func.isRequired,
  handleChangeRowsPerPage: PropTypes.func.isRequired,
  handleChangePage: PropTypes.func.isRequired
};

export default injectIntl(ImitateEmployeePage);
